import { useContext } from "react";
import { useQuery } from "react-query";
import AuthContext from "contexts/AuthContext";

const { REACT_APP_API } = process.env;

export const getImages = async ({ accessToken, caseId }) => {
  const response = await fetch(
    `${REACT_APP_API}/v2/takeback/get-images?caseId=${encodeURIComponent(caseId)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  if (!response.ok) {
    const body = await response.text();
    throw new Error(`Failed to get images: ${body}`);
  }

  return await response.json();
};

export const useGetImages = (caseId) => {
  const { user, authTokens } = useContext(AuthContext);
  const username = user?.email;
  const accessToken = authTokens?.access_token;

  return useQuery(
    ["get-images", caseId, username],
    () => getImages({ accessToken, caseId }),
    {
      enabled: !!caseId && !!accessToken,
    }
  );
};
